import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTarget = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M11 12a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M7 12a5 5 0 1 0 10 0a5 5 0 1 0 -10 0" }),
		/* @__PURE__ */ _jsx("path", { d: "M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" })
	]
});
export { SvgTarget as ReactComponent };
